import { Link } from 'react-router-dom';
import { MoveLeftIcon } from 'lucide-react';

import { buttonVariants } from '@design-system/button';
import { cn } from '@design-system/helpers';

import { createRoute, PATHS } from '@src/core/router/paths';

export default function BackButton() {
  return (
    <Link
      to={createRoute(PATHS.PARTICIPANTS)}
      className={cn(
        buttonVariants({ size: 'iconSm', variant: 'primaryOutline' }),
        'rounded-full border-pale-border'
      )}
    >
      <MoveLeftIcon />
    </Link>
  );
}
